import { Box, Stack, Tooltip } from "@mui/material";
import { BiggerThanSmallAndSmallerThanMediumText } from "../../../common/styles/Text.styles";
import {
  defaultTransition,
  perelynBlack,
  perelynRed,
  smallGap
} from "../../../styles/consts";

const getGradientColor = (index: number, total: number) => {
  const startColor = {
    r: parseInt(perelynBlack.slice(1, 3), 16),
    g: parseInt(perelynBlack.slice(3, 5), 16),
    b: parseInt(perelynBlack.slice(5, 7), 16)
  };
  
  const endColor = {
    r: parseInt(perelynRed.slice(1, 3), 16),
    g: parseInt(perelynRed.slice(3, 5), 16),
    b: parseInt(perelynRed.slice(5, 7), 16)
  };

  const percent = index / (total - 1);
  
  const r = Math.round(startColor.r + percent * (endColor.r - startColor.r));
  const g = Math.round(startColor.g + percent * (endColor.g - startColor.g));
  const b = Math.round(startColor.b + percent * (endColor.b - startColor.b));
  
  return `rgb(${r}, ${g}, ${b})`;
};

export default function RatingScale({ title, description, rating, setRating }) {
  return (
    <Stack>
      <Tooltip title={description} placement="right">
        <BiggerThanSmallAndSmallerThanMediumText sx={{
          width: "fit-content"
        }}>{title}</BiggerThanSmallAndSmallerThanMediumText>
      </Tooltip>
      <Stack
        sx={{
          flexDirection: "row",
          gap: smallGap,
          alignItems: "center",
          height: "4rem",
        }}
      >
        {[...Array(10)].map((_, i) => {
          const isCurrentlySelected = rating === i + 1;
          const backgroundColor = getGradientColor(i, 10);
          
          return (
            <Box
              key={i}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: isCurrentlySelected ? "3rem" : "2rem",
                height: isCurrentlySelected ? "3rem" : "2rem",
                fontSize: isCurrentlySelected ? "18px" : "14px",
                color: "white",
                transition: defaultTransition,
                backgroundColor,
                borderRadius: "200px",
                cursor: "pointer",
                boxShadow: "0 0 1rem rgba(0, 0, 0, 0.125)",
                fontWeight: isCurrentlySelected ? "600" : "400",
                "&:hover": {
                  opacity: "0.5",
                },
              }}
              onClick={() => setRating(i + 1)}
            >
              {i + 1}
            </Box>
          );
        })}
      </Stack>
    </Stack>
  );
}
